import { useToastStore } from './toastStore'
import { ToastItem } from './ToastItem'

export const Toaster = () => {
  const toasts = useToastStore((s) => s.toasts)
  const remove = useToastStore((s) => s.remove)

  if (toasts.length === 0) return null

  return (
    <div
      className="fixed bottom-4 left-1/2 z-[100] flex w-full max-w-[calc(100vw-2rem)] -translate-x-1/2 flex-col gap-2 px-4 md:bottom-auto md:left-auto md:right-6 md:top-6 md:translate-x-0"
      aria-label="Notificações"
    >
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={remove} />
      ))}
    </div>
  )
}
